import { ProtectedRoute } from '@/components/protected-route';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui';
import { oauthConfig } from '@/config/oauth-config';
import { AuthProvider } from '@/contexts/auth-context';
import { SettingsProvider } from '@/contexts/settings-context';
import { ConnectionProvider } from '@/features/connections/connection-context';
import { Explorer } from '@/features/firestore/pages/explorer';
import { AuthPage } from '@/pages/auth-page';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

export function App() {
  const appContent = (
    <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <AuthProvider>
        <SettingsProvider>
          <Toaster>
            <BrowserRouter>
              <ConnectionProvider>
                <Routes>
                  <Route path="/auth" element={<AuthPage />} />
                  <Route
                    path="/app/explorer"
                    element={
                      <ProtectedRoute>
                        <Explorer />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <Navigate to="/app/explorer" replace />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </ConnectionProvider>
            </BrowserRouter>
          </Toaster>
        </SettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  );

  // Wrap with GoogleOAuthProvider if client ID is configured
  // Use placeholder if not configured (prevents library error, but OAuth won't work)
  const clientId =
    oauthConfig.google.clientId || 'placeholder.client.id.apps.googleusercontent.com';

  if (!oauthConfig.google.clientId) {
    console.warn(
      'Google OAuth Client ID is not configured. Set VITE_GOOGLE_OAUTH_CLIENT_ID in your .env file.'
    );
  }

  return <GoogleOAuthProvider clientId={clientId}>{appContent}</GoogleOAuthProvider>;
}
